import { useTranslation } from 'react-i18next'

import { Badge, BadgeColorKeys } from '@/components/ui/badge'

import { PlaceStatus } from '../places.status-filter'

const STATUS_COLOR: Record<PlaceStatus, BadgeColorKeys> = {
  active: 'green',
  delinquent: 'orange',
  inactive: 'neutral',
  suspended: 'red',
}

interface PlaceStatusBadgeProps {
  status: PlaceStatus
}

export const PlaceStatusBadge = ({ status }: PlaceStatusBadgeProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <Badge color={STATUS_COLOR[status]} size="small" variant="light">
      {t(`organisation:places.statuses.${status}`)}
    </Badge>
  )
}
